import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon, TargetIcon } from "lucide-react";
import { CheckList } from "./CheckList";
type Volume = {
  label: string;
  color: string;
  title: string;
  intro: string;
  items: string[];
  note?: string;
  goal: string;
};
export function VolumeCard({
  volume
}: {
  volume: Volume;
}) {
  const [open, setOpen] = useState(false);
  return <article className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-line" data-id="element-361" data-mp="1uswhhfxzsyxn">
      <div className="px-5 py-4 md:px-7" style={{
      backgroundColor: volume.color
    }} data-id="element-362" data-mp="1pvmk9e4d3iz9">
        <p className="font-display text-sm font-black uppercase tracking-wide text-white/80" data-id="element-363" data-mp="1l2thuwwd8mqc">{volume.label}</p>
        <h3 className="mt-1 font-display text-xl font-black uppercase leading-tight text-white md:text-2xl" data-id="element-364" data-mp="1h186jfzhcgi9">
          {volume.title}
        </h3>
      </div>
      <div className="p-5 md:p-7" data-id="element-365" data-mp="28t76sejnm5gp">
        <p className="text-base leading-relaxed text-muted md:text-lg" data-id="element-366" data-mp="28s4hgb1zcb2w">{volume.intro}</p>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="mt-5 flex w-full items-center justify-between gap-3 rounded-xl bg-paper px-4 py-3 text-left font-display text-sm font-extrabold uppercase tracking-wide text-ink transition-colors duration-150 ease-out hover:bg-brand-light" data-id="element-367" data-mp="37bquv2n4i2m4">
          <span data-id="element-368" data-mp="2olizj6po0ggh">Inside, you’ll explore ({volume.items.length} topics)</span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 transition-transform duration-200 ease-out ${open ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-369" data-mp="2onlwybt5dbv8" />
        </button>
        <AnimatePresence initial={false} data-id="element-370" data-mp="2epfy632n0lul">
          {open && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: "auto",
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.25,
          ease: [0.23, 1, 0.32, 1]
        }} className="overflow-hidden" data-id="element-371" data-mp="2jn7nqqft7vvm">
              <div className="pt-5" data-id="element-372" data-mp="gfh244z2k3av">
                <CheckList items={volume.items} color={volume.color} columns data-id="element-373" data-mp="gbjizjchrbqz" />
                {volume.note && <p className="mt-4 text-sm italic leading-relaxed text-muted" data-id="element-374" data-mp="bh5qbop7riq0">{volume.note}</p>}
              </div>
            </motion.div>}
        </AnimatePresence>

        <div className="mt-5 flex items-start gap-3 rounded-xl border-l-4 p-4" style={{
        borderColor: volume.color,
        backgroundColor: `${volume.color}12`
      }} data-id="element-375" data-mp="2fxv5fhzuy05">
          <TargetIcon className="mt-0.5 h-5 w-5 shrink-0" style={{
          color: volume.color
        }} aria-hidden="true" data-id="element-376" data-mp="u50z0u5yy6c9" />
          <p className="text-base leading-snug text-ink" data-id="element-377" data-mp="pdiyg77uy7rt">
            <strong className="font-display font-black uppercase" data-id="element-378" data-mp="lcz235v3z86q">The goal:</strong> {volume.goal}
          </p>
        </div>
      </div>
    </article>;
}